import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useFooterWebsiteDocumentDetails } from "./Footer.hooks";

const AddEditFooterWebsite = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editFooterWebsite,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchFooterWebsite,
  } = useFooterWebsiteDocumentDetails(query.get("editId") || "");

  const {
    data: editFooterWebsiteById,
    isLoading: isLoadingFooterWebsite,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "footerwebsite") {
      refetchFooterWebsite();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchFooterWebsite();
    }
  }, [query.get("editId"), query.get("id")]);

  const appAboutFormConfig: FormConfig = {
    initialValues: {
      title: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.title)
        : decodeHTML(editFooterWebsite?.title),

      copyrightText: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.copyrightText)
        : decodeHTML(editFooterWebsite?.copyrightText),

      field_copyright_text_ms: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_copyright_text_ms)
        : decodeHTML(editFooterWebsite?.field_copyright_text_ms),

      field_copyright_text_zh: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_copyright_text_zh)
        : decodeHTML(editFooterWebsite?.field_copyright_text_zh),

      registrationText: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.registrationText)
        : decodeHTML(editFooterWebsite?.registrationText),

      field_registration_number_txt_ms: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_registration_number_txt_ms)
        : decodeHTML(editFooterWebsite?.field_registration_number_txt_ms),

      field_registration_number_txt_zh: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_registration_number_txt_zh)
        : decodeHTML(editFooterWebsite?.field_registration_number_txt_zh),

      mobileAppText: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.mobileAppText)
        : decodeHTML(editFooterWebsite?.mobileAppText),

      field_mobile_app_text_ms: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_mobile_app_text_ms)
        : decodeHTML(editFooterWebsite?.field_mobile_app_text_ms),

      field_mobile_app_text_zh: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_mobile_app_text_zh)
        : decodeHTML(editFooterWebsite?.field_mobile_app_text_zh),

      termsOfUseText: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.termsOfUseText)
        : decodeHTML(editFooterWebsite?.termsOfUseText),

      field_term_of_use_text_ms: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_term_of_use_text_ms)
        : decodeHTML(editFooterWebsite?.field_term_of_use_text_ms),

      field_term_of_use_text_zh: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_term_of_use_text_zh)
        : decodeHTML(editFooterWebsite?.field_term_of_use_text_zh),

      termsOfUseLink: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.termsOfUseLink)
        : decodeHTML(editFooterWebsite?.termsOfUseLink),

      privacyPolicyText: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.privacyPolicyText)
        : decodeHTML(editFooterWebsite?.privacyPolicyText),

      field_privacy_policy_text_ms: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_privacy_policy_text_ms)
        : decodeHTML(editFooterWebsite?.field_privacy_policy_text_ms),

      field_privacy_policy_text_zh: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.field_privacy_policy_text_zh)
        : decodeHTML(editFooterWebsite?.field_privacy_policy_text_zh),

      privacyPolicyLink: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.privacyPolicyLink)
        : decodeHTML(editFooterWebsite?.privacyPolicyLink),

      playStoreImage: editFooterWebsiteById?.payload?.playStoreImage
        ? [
            {
              uid: "-1",
              name: "playstore.jpg",
              status: "done",
              url: decodeHTML(editFooterWebsiteById.payload.playStoreImage),
            },
          ]
        : editFooterWebsite?.playStoreImage
          ? [
              {
                uid: "-1",
                name: "playstore.jpg",
                status: "done",
                url: decodeHTML(editFooterWebsite.playStoreImage),
              },
            ]
          : [],

      playStoreLink: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.playStoreLink)
        : decodeHTML(editFooterWebsite?.playStoreLink),

      appStoreImage: editFooterWebsiteById?.payload?.appStoreImage
        ? [
            {
              uid: "-1",
              name: "appstore.jpg",
              status: "done",
              url: decodeHTML(editFooterWebsiteById.payload.appStoreImage),
            },
          ]
        : editFooterWebsite?.appStoreImage
          ? [
              {
                uid: "-1",
                name: "appstore.jpg",
                status: "done",
                url: decodeHTML(editFooterWebsite.appStoreImage),
              },
            ]
          : [],

      appStoreLink: editFooterWebsiteById?.payload
        ? decodeHTML(editFooterWebsiteById.payload.appStoreLink)
        : decodeHTML(editFooterWebsite?.appStoreLink),
    },
    fields: fields.footerweb,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["appStoreImage", "playStoreImage"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (Array.isArray(field) && field.length > 0) {
          const fileItem = field[0];

          if (fileItem.originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", fileItem.originFileObj);
            formData.append("application", "PASSENGER");
            const res: any = await post("management/upload-file", formData);

            if (res?.response?.data) {
              data[key] = res.response.data;
            } else {
              data[key] = "";
            }
          } else if (fileItem.url) {
            data[key] = fileItem.url;
          } else {
            data[key] = "";
          }
        } else {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Footer",
      subModule: "footerweb",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editFooterWebsite?.id || editFooterWebsiteById?.payload?.id }),
        ...data,
      },
      status: status,
    };

    // console.log(payload, "tested");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingFooterWebsite || drilldownLoading}
        config={appAboutFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${passengerHost}/api/webapp-footer-crud-api-data/${editFooterWebsite?.id || editFooterWebsiteById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Footer"
      />
    </>
  );
};

export default AddEditFooterWebsite;
